import { FC } from 'react';
import { Box, Center, Spinner, Modal, ModalOverlay } from '@chakra-ui/react';

type Props = {
  isOpen: boolean;
};

export const ModalSpinner: FC<Props> = (props) => {
  const { isOpen } = props;
  return (
    <Modal isOpen={isOpen} onClose={() => {}}>
      <Box position={'relative'}>
        <ModalOverlay>
          <Center
            verticalAlign={'middle'}
            display={'flex'}
            position={'absolute'}
            zIndex={10000} // ModalOverlayが 1300 程度
            top={'50%'}
            left={'45%'}
          >
            <Spinner
              size="xl"
              speed="0.85s"
              color="teal.200"
              fontWeight={'bold'}
            />
          </Center>
        </ModalOverlay>
      </Box>
    </Modal>
  );
};
